import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="page">
      <h1>Cookie Policy</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default CookiePolicy; 